/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Category_SearchInputs */

const en_category_search = /** @type {(inputs: Category_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search & SEO`)
};

const zh_hans1_category_search = /** @type {(inputs: Category_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索与 SEO`)
};

const pt_br2_category_search = /** @type {(inputs: Category_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busca e SEO`)
};

const es_category_search = /** @type {(inputs: Category_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda y SEO`)
};

const fr_category_search = /** @type {(inputs: Category_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche et SEO`)
};

const de_category_search = /** @type {(inputs: Category_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche & SEO`)
};

const ru_category_search = /** @type {(inputs: Category_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск и SEO`)
};

const it_category_search = /** @type {(inputs: Category_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca e SEO`)
};

/**
* | output |
* | --- |
* | "Search & SEO" |
*
* @param {Category_SearchInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const category_search = /** @type {((inputs?: Category_SearchInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Category_SearchInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_category_search(inputs)
	if (locale === "pt-BR") return pt_br2_category_search(inputs)
	if (locale === "es") return es_category_search(inputs)
	if (locale === "fr") return fr_category_search(inputs)
	if (locale === "de") return de_category_search(inputs)
	if (locale === "ru") return ru_category_search(inputs)
	if (locale === "it") return it_category_search(inputs)
	return en_category_search(inputs)
});